module.exports = __webpack_public_path__ + "static/media/7ae2208f.jpg";